import {
    SET_ADM_DATA_MANAGEMENT_LOADING,
    SET_ADM_DATA_MANAGEMENT_SUCCESS,
    SET_ADM_DATA_MANAGEMENT_ERROR,
    SET_ADM_DATA_MANAGEMENT_RESULT,
    GET_DB_CAPACITY_INFO,
    GET_DB_CAPACITY_INFO_SUCCESS,
    GET_BACKUP_INFO,
    GET_BACKUP_INFO_SUCCESS,
    CHANGE_BACKUP_INFO,
    SAVE_BACKUP_INFO,
    SAVE_BACKUP_INFO_SUCCESS,
    GET_MADRID_CRAWL_INFO,
    GET_MADRID_CRAWL_INFO_SUCCESS,
    GET_HAGUE_CRAWL_INFO,
    GET_HAGUE_CRAWL_INFO_SUCCESS,
    GET_PCT_CRAWL_INFO,
    GET_PCT_CRAWL_INFO_SUCCESS,
    GET_MADRID_PDF_ERROR_INFO,
    GET_MADRID_PDF_ERROR_INFO_SUCCESS,
    GET_MADRID_DISCREPENCY_INFO,
    GET_MADRID_DISCREPENCY_INFO_SUCCESS,
    GET_SERVERS_INFO,
    GET_SERVERS_INFO_SUCCESS,
    GET_EMAIL_SERVER_INFO,
    GET_EMAIL_SERVER_INFO_SUCCESS,
    CHANGE_MADRID_PDF_ERROR_INFO,
    GET_REMAINING_INFO,
    GET_REMAINING_INFO_SUCCESS,
    SAVE_MADRID_PDF_ERROR_INFO,
    SAVE_MADRID_PDF_ERROR_INFO_SUCCESS,
    CHANGE_EMAIL_SERVER_INFO,
    SAVE_EMAIL_SERVER_INFO,
    SAVE_EMAIL_SERVER_INFO_SUCCESS,
    GET_ROMARIAN_INFO,
    GET_ROMARIAN_INFO_SUCCESS,
} from "./actionTypes";

const initialState = {
    error: "",
    loading: false,
    success: "",
    result: -1,
    totalPage: 1,

    totalPageDbCapacity: 0,
    noticeStrDbCapacity: "",
    dbCapacityInfoList: [],
    dbCurrentUsage: "",

    totalPageMadrid: 0,
    noticeStrMadrid: "",
    madridCrawlInfoList: [],

    totalPageHague: 0,
    noticeStrHague: "",
    hagueCrawlInfoList: [],

    totalPagePct: 0,
    noticeStrPct: "",
    pctCrawlInfoList: [],

    totalPageError: 0,
    noticeStrError: "",
    pdfErrorInfoList: [],

    totalPageDiscrepency: 0,
    noticeStrDiscrepency: "",
    discrepencyInfoList: [],

    totalPageServer: 0,
    noticeStrServer: "",
    serverInfoList: [],

    totalPageEmailServer: 0,
    noticeStrEmailServer: "",
    emailServerInfoList: [],

    totalPageBackup: 0,
    noticeStrBackup: "",
    backupInfoList: [],

    madridRemaining: 0,
    madridPdfRemaining: 0,
    hagueRemaining: 0,
    pctRemaining: 0,

    totalPageEmailServer: 0,
    noticeStrEmailServer: "",
    emailServerInfoList: [],

    madridRomarianInfo: [],
    madridRomarianInfoActive: [],
    hagueRomarianInfo: [],
    hagueRomarianInfoActive: []
}

const AdmDataManagement = (state = initialState, action) => {
    switch (action.type) {
        case SET_ADM_DATA_MANAGEMENT_LOADING:
            state = {
                ...state,
                loading: action.payload,
            }
            break
        case SET_ADM_DATA_MANAGEMENT_SUCCESS:
            state = {
                ...state,
                success: action.payload,
            }
            break
        case SET_ADM_DATA_MANAGEMENT_ERROR:
            state = {
                ...state,
                error: action.payload,
            }
            break
        case SET_ADM_DATA_MANAGEMENT_RESULT:
            state = {
                ...state,
                result: action.payload,
            }
            break
        case GET_DB_CAPACITY_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_DB_CAPACITY_INFO_SUCCESS:
            state = {
                ...state,
                totalPageDbCapacity: action.payload.totalPage || 0,
                dbCapacityInfoList: action.payload.result,
                noticeStrDbCapacity: action.payload.noticeStr || "",
                dbCurrentUsage: action.payload.currentUsage || "",
                error: action.payload.result === -1 ? "Error while retrieving DB capacity info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_MADRID_CRAWL_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_MADRID_CRAWL_INFO_SUCCESS:
            state = {
                ...state,
                totalPageMadrid: action.payload.totalPage || 0,
                madridCrawlInfoList: action.payload.result,
                noticeStrMadrid: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving madrid info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_HAGUE_CRAWL_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_HAGUE_CRAWL_INFO_SUCCESS:
            state = {
                ...state,
                totalPageHague: action.payload.totalPage || 0,
                hagueCrawlInfoList: action.payload.result,
                noticeStrHague: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving hague info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_PCT_CRAWL_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_PCT_CRAWL_INFO_SUCCESS:
            state = {
                ...state,
                totalPagePct: action.payload.totalPage || 0,
                pctCrawlInfoList: action.payload.result,
                noticeStrPct: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving pct info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_MADRID_PDF_ERROR_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_MADRID_PDF_ERROR_INFO_SUCCESS:
            state = {
                ...state,
                totalPageError: action.payload.totalPage || 0,
                pdfErrorInfoList: action.payload.result,
                noticeStrError: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving error info: contact system administrator!" : "",
                loading: false,
            }
            break
        
        case CHANGE_MADRID_PDF_ERROR_INFO:
            state = {
                ...state,
                pdfErrorInfoList: action.payload
            }
            break
        case SAVE_MADRID_PDF_ERROR_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case SAVE_MADRID_PDF_ERROR_INFO_SUCCESS:
            state = {
                ...state,
                error: action.payload.result === -1 ? "Error while saving error info: contact system administrator!" : "",
                success: action.payload.success,
                loading: false,
            }
            break
        case GET_MADRID_DISCREPENCY_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_MADRID_DISCREPENCY_INFO_SUCCESS:
            state = {
                ...state,
                totalPageDiscrepency: action.payload.totalPage || 0,
                discrepencyInfoList: action.payload.result,
                noticeStrDiscrepency: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving discrepency info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_SERVERS_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_SERVERS_INFO_SUCCESS:
            state = {
                ...state,
                totalPageServer: action.payload.totalPage || 0,
                serverInfoList: action.payload.result,
                noticeStrServer: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving servers info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_EMAIL_SERVER_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_EMAIL_SERVER_INFO_SUCCESS:
            state = {
                ...state,
                totalPageEmailServer: action.payload.totalPage || 0,
                emailServerInfoList: action.payload.result,
                noticeStrEmailServer: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving email server info: contact system administrator!" : "",
                loading: false,
            }
            break
        case CHANGE_EMAIL_SERVER_INFO:
            state = {
                ...state,
                emailServerInfoList: action.payload
            }
            break
        case SAVE_EMAIL_SERVER_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case SAVE_EMAIL_SERVER_INFO_SUCCESS:
            state = {
                ...state,
                error: action.payload.result === -1 ? "Error while saving backup info: contact system administrator!" : "",
                success: action.payload.success,
                loading: false,
            }
            break
        case GET_BACKUP_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_BACKUP_INFO_SUCCESS:
            state = {
                ...state,
                totalPageBackup: action.payload.totalPage || 0,
                backupInfoList: action.payload.result,
                noticeStrBackup: action.payload.noticeStr || "",
                error: action.payload.result === -1 ? "Error while retrieving backup info: contact system administrator!" : "",
                loading: false,
            }
            break
        case CHANGE_BACKUP_INFO:
            state = {
                ...state,
                backupInfoList: action.payload
            }
            break
        case SAVE_BACKUP_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case SAVE_BACKUP_INFO_SUCCESS:
            state = {
                ...state,
                error: action.payload.result === -1 ? "Error while saving backup info: contact system administrator!" : "",
                success: action.payload.success,
                loading: false,
            }
            break
        case GET_REMAINING_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_REMAINING_INFO_SUCCESS:
            state = {
                ...state,
                madridRemaining: action.payload.madridRemaining || 0,
                madridPdfRemaining: action.payload.madridPdfRemaining || 0,
                hagueRemaining: action.payload.hagueRemaining || 0,
                pctRemaining: action.payload.pctRemaining || 0,
                error: action.payload.result === -1 ? "Error while retrieving backup info: contact system administrator!" : "",
                loading: false,
            }
            break
        case GET_ROMARIAN_INFO:
            state = {
                ...state,
                loading: true,
            }
            break
        case GET_ROMARIAN_INFO_SUCCESS:
            console.log("length: " , action.payload.result?.length)
            if (action.payload.ftp === 'Madrid') {
                state = {
                    ...state,
                    madridRomarianInfo: action.payload.result,
                    error: action.payload.result === -1 ? "Error while retrieving romarian info: contact system administrator!" : "",
                    loading: false,
                }
            } else {
                state = {
                    ...state,
                    hagueRomarianInfo: action.payload.result,
                    error: action.payload.result === -1 ? "Error while retrieving romarian info: contact system administrator!" : "",
                    loading: false,
                }
            }
            
            break
        default:
            state = { ...state }
            break
    }
    return state
}

export default AdmDataManagement;
